import { Checkbox } from "primereact/checkbox";
import { subNumCounting } from "../../../utils/constants";
import { Button } from "primereact/button";
import AddQuestionComponent from "./AddQuestionComponent";
import { useLayoutEffect, useRef, useState } from "react";
import LogicDialog from "../logicDialog/LogicDialog";

const radioButtons = [
  { id: 1, label: "Open Ended Question", value: "open_ended_question" },
  {
    id: 2,
    label: "Multiple Choice - Single Select",
    value: "multiple_choice_single_select",
    showInfoIcon: true,
  },
  {
    id: 3,
    label: "Multiple Choice - Multi-Select",
    value: "multiple_choice_multi_select",
    showInfoIcon: true,
  },
  {
    id: 4,
    label: "Rating Question",
    value: "rating_question",
    showInfoIcon: true,
  },
  {
    id: 5,
    label: "Ranking Question",
    value: "ranking_question",
    showInfoIcon: true,
  },
];

const TaskSubQues = ({
  subTaskQues,
  taskIndex,
  updateSubTQItem,
  deleteSubTQ,
  cloneSubTQ,
  handleShuffle,
  scrollToIndex,
  updateSubTQItemNestedPath,
  isLocked = false,
  surveyType = "",
  onDeleteSkipLogic,
  deleteSlLoading,
  taskQuestions,
  parentTask,
  setTaskquestion,
  updateTaskItemWithChildIndex,
}) => {
  const subTaskQuesRefs = useRef([]);
  const [isSLDialogVisible, setIsSLDialogVisible] = useState(false);
  const [selectedTQIndex, setSelectedTQIndex] = useState(null);
  const [selectedChildQuesIndex, setSelectedChildQuesIndex] = useState(null);

  // Scroll to the inserted index after render
  useLayoutEffect(() => {
    const index = scrollToIndex.current;
    if (index != null && subTaskQuesRefs.current[index]) {
      subTaskQuesRefs.current[index].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      scrollToIndex.current = null; // clear after scrolling
    }
  }, [subTaskQues.length, scrollToIndex]);

  return (
    <div>
      {subTaskQues.map((subTaskQue, index) => (
        <div
          key={`subques-${index}`}
          ref={(el) => (subTaskQuesRefs.current[index] = el)}
        >
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <Checkbox
                inputId={`subtask-${index}`}
                checked={subTaskQue?.isSubTQSelected}
                onChange={(e) => {
                  updateSubTQItem(index, taskIndex, "", e.checked, false);
                }}
                disabled={isLocked}
              />
              <label htmlFor={`subtask-${index}`} className="ms-2">
                <span className="me-1">
                  {taskIndex + 1}
                  {subNumCounting[index]}.
                </span>
                Question:
              </label>
            </div>
            <div className="d-flex align-items-center">
              <i className="pi pi-cog fs-14"></i>
              <Button
                className="fw-bold fs-14 px-2"
                link
                onClick={() => {
                  setIsSLDialogVisible(true);
                  setSelectedTQIndex(taskIndex);
                  setSelectedChildQuesIndex(index);
                }}
                disabled={isLocked}
              >
                Logic
              </Button>

              <span className="me-2">|</span>

              <i className="pi pi-clone fs-14"></i>
              <Button
                className="fw-bold fs-14 px-2"
                link
                onClick={() => cloneSubTQ(index, taskIndex)}
                disabled={isLocked}
              >
                Clone
              </Button>

              <span className="me-2">|</span>

              <i className="pi pi-trash fs-14"></i>
              <Button
                className="fw-bold fs-14 px-2"
                link
                onClick={() =>
                  deleteSubTQ(
                    index,
                    "TaskQuestion",
                    subTaskQue?.question_id,
                    true,
                    taskIndex,
                  )
                }
                disabled={isLocked}
              >
                Delete
              </Button>
            </div>
          </div>
          <div className="mt-2 mb-2">
            <AddQuestionComponent
              index={index}
              taskQuestion={subTaskQue}
              radioButtons={radioButtons}
              updateQuestionItem={(updateItem, value) =>
                // updateSubTQItem(index, taskIndex, updateItem, value, true)
                updateTaskItemWithChildIndex(updateItem, value, index)
              }
              updateSubTQItemNestedPath={(updateItem, value) =>
                updateSubTQItemNestedPath(
                  index,
                  taskIndex,
                  updateItem,
                  value,
                  true,
                )
              }
              answerOptionText={`${taskIndex + 1}${subNumCounting[index]}`}
              type={"subTQ"}
              quesCount={`${taskIndex + 1}${subNumCounting[index]}`}
              handleShuffle={handleShuffle}
              isLocked={isLocked}
              surveyType={surveyType}
              taskIndex={taskIndex}
            />
          </div>
        </div>
      ))}

      {isSLDialogVisible ? (
        <LogicDialog
          isSLDialogVisible={isSLDialogVisible}
          setIsSLDialogVisible={setIsSLDialogVisible}
          taskQuestions={taskQuestions}
          setTaskquestion={setTaskquestion}
          setSelectedTQIndex={setSelectedTQIndex}
          selectedTQIndex={selectedTQIndex}
          onDeleteSkipLogic={onDeleteSkipLogic}
          deleteSlLoading={deleteSlLoading}
          selectedChildQuesIndex={selectedChildQuesIndex}
          isSubQuestion={true}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default TaskSubQues;
